// extracted by mini-css-extract-plugin
export default {"bgBlue":"CustomBreadcrumb_bgBlue__9ABZr","bgTransparent":"CustomBreadcrumb_bgTransparent__J+qAw","content":"CustomBreadcrumb_content__lkptc"};